import axios from 'axios';

export const FETCH_JURISDICTIONS = 'FETCH_JURISDICTIONS';

export function fetchJurisdictionsDispatch() {

	return ( dispatch, getState ) => {
		'use strict';
		const url = `${wpApiSettings.root}isda/v1/informal-country-update`;
		axios.get( url ).then( response => {

			return dispatch( {
				                 type   : FETCH_JURISDICTIONS,
				                 payload: response.data
			                 } );
		} );

	};
}